// 20220112184002
// https://api.github.com/users/mahfod-dev

export default {
	login: 'Mahfod-dev',
	id: 62814940,
	node_id: 'MDQ6VXNlcjYyODE0OTQw',
	avatar_url: 'https://avatars.githubusercontent.com/u/62814940?v=4',
	gravatar_id: '',
	url: 'https://api.github.com/users/Mahfod-dev',
	html_url: 'https://github.com/Mahfod-dev',
	followers_url: 'https://api.github.com/users/Mahfod-dev/followers',
	following_url:
		'https://api.github.com/users/Mahfod-dev/following{/other_user}',
	gists_url: 'https://api.github.com/users/Mahfod-dev/gists{/gist_id}',
	starred_url: 'https://api.github.com/users/Mahfod-dev/starred{/owner}{/repo}',
	subscriptions_url: 'https://api.github.com/users/Mahfod-dev/subscriptions',
	organizations_url: 'https://api.github.com/users/Mahfod-dev/orgs',
	repos_url: 'https://api.github.com/users/Mahfod-dev/repos',
	events_url: 'https://api.github.com/users/Mahfod-dev/events{/privacy}',
	received_events_url:
		'https://api.github.com/users/Mahfod-dev/received_events',
	type: 'User',
	site_admin: false,
	name: 'Mahfod',
	company: 'mahfod-dev',
	blog: '',
	location: 'France',
	email: null,
	hireable: null,
	bio: 'More Learn more Dev......',
	twitter_username: 'Mahfod',
	public_repos: 12,
	public_gists: 0,
	followers: 4,
	following: 6,
	created_at: '2020-03-28T21:02:59Z',
	updated_at: '2022-01-12T17:38:16Z',
}
